export default "__VITE_PUBLIC_ASSET__78809286__"